import { TeamsListPayload } from 'app/modules/teams/requests';

const BASE = ['teams'] as const;

export const TEAM_QUERY_KEYS = {
  getTeam: (id: number) => [...BASE, 'team', id] as const,
  getAllTeams: () => [...BASE, 'teams-list'] as const,
  getTeamsList: (payload: TeamsListPayload) =>
    [...TEAM_QUERY_KEYS.getAllTeams(), payload] as const,
};
